module.exports = __webpack_public_path__ + "img/C07TechFireshipChampion_ua.a080e564.webp";